import React from "react";

const CALCULATOR_PATH = "/federal-poverty-guideline-calculator";

const openCalculatorInNewTab = (event: React.MouseEvent<HTMLAnchorElement>) => {
  event.preventDefault();
  window.open(CALCULATOR_PATH, "_blank", "noopener,noreferrer");
};

const PovertyGuidelineHelp: React.FC = () => (
  <div className="rounded-2xl border border-[#D9E2EC] bg-[#F8FBFD] p-5 md:p-6">
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div>
        <p className="text-[12px] font-bold uppercase tracking-wide text-[#C1804D]">
          Household income check
        </p>
        <h2 className="mt-1 text-[20px] font-bold text-[#1B365D]">
          Need help with the 400% Federal Poverty Guideline question?
        </h2>
        <p className="mt-2 text-sm leading-6 text-[#1B365DCC]">
          Use the calculator to compare your annual household income with the
          guideline for your family size and location. It opens separately so
          your questionnaire answers stay on this page.
        </p>
      </div>
      <a
        href={CALCULATOR_PATH}
        target="_blank"
        rel="noopener noreferrer"
        onClick={openCalculatorInNewTab}
        className="inline-flex shrink-0 items-center justify-center rounded-[50px] border border-[#1B365D] px-5 py-3 text-sm font-bold text-[#1B365D] transition-colors hover:bg-[#1B365D] hover:text-white"
      >
        Open calculator
      </a>
    </div>
  </div>
);

export default PovertyGuidelineHelp;
